import fr from 'facet-rest';
import BaseOverride from 'Views/Page/Content/Templates/WhatIfTemplate/BaseOverride';
import DateField from 'Components/ComponentLibrary/Components/Uncategorized/DateField';
import moment from 'moment';
import { defaultFormat } from 'Consts/DateFormats';

export default fr.metaOverride({ base: BaseOverride })
  .nameOverride('dateOfBirth', {
    _component: () => DateField,
    _customProps: {
      openTo: 'year',
      views: ['year', 'month', 'date'],
    },
    _transformValue: () => (v) => {
      if (!v) {
        return '';
      }
      return moment.utc(v).format(defaultFormat);
    },
  });
